import { useGetProjectById } from "@/lib/useQuery/project/useGetProjectById";
import { setProjectContext } from "@/lib/utils/sentry/context/setProjectContext";
import { useCrmStore, useProjectStore } from "@/lib/zustand/useStore";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
export default function ProjectProvider() {
    const { projectId } = useParams()
    const { setCrmProject, setCrm } = useCrmStore();
    const { data: project } = useGetProjectById({ projectId })
    const { setProject, project: storeProject } = useProjectStore();
    useEffect(() => {
        if (project) {
            setProject(project)
            setCrmProject(project.crm_project)
            if (project.crm_project?.crm) {
                setCrm(project.crm_project?.crm)
            }
        }
    }, [projectId, project, setProject, setCrmProject, setCrm])
    useEffect(() => {
        setProjectContext(storeProject);
    }, [storeProject]);
    return (
        <>
            <Outlet />
        </>
    )
}